<template>
  <div>
    <modal-vue v-if="showModal" @close="showModal = false, selectedLesson = null">
      <h3 slot="header">Upload de Arquivo</h3>

      <div slot="body">
        <div class="modules-content" style="overflow-y: scroll;padding-right:0px;padding-left:0px;">
          <div class="module-item">
            <div class="control-group">
              <label class="control-label" for="teacher">Compartilhar como:</label>
              <select
                v-model="uploadType"
                id="teacher"
                class="form-control"
              >
                <option value="0">Material Complementar</option>
                <option value="1">Exercício</option>
              </select>
            </div>
            <br />
            <br />

            <ul class="lessons-list">
              <li class="lesson-subtitle custom-grid-modal">
                <span class="lesson-title">Adicione o arquivo</span>
              </li>

              <li class="lesson custom-grid-modal">
                <div class="large-12 medium-12 small-12 cell">
                  <input
                    type="file"
                    id="files"
                    ref="files"
                    v-on:change="handleFilesUpload()"
                  />
                </div>
                <div class="large-12 medium-12 small-12 cell">
                  <div v-for="(file, key)  in files" :key="file.name" class="file-listing">
                    {{ file.name }}
                    <button @click="removeFile( key )" :disabled="uploadingFiles == true" class="btn btn-success">
                      Remover Arquivo
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <br />
                <div class="large-12 medium-12 small-12 cell">
                  <button @click="submitFiles()" :disabled="files.length < 1 || uploadingFiles == true" class="btn btn-success">
                    Carregar para o servidor
                    <i class="fa fa-upload"></i>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div slot="footer">
        <button class="btn btn-default" @click="showModal = false">Fechar</button>
      </div>
    </modal-vue>

    <execute-quiz
      @close="executeQuiz=false;getModules();"
      v-if="executeQuiz"
      :moduleId="selectedModuleId"
    />

    <div v-if="loading" class="title-section-content">
      <h3>Carregando...</h3>
      <br />
      <loading :color="'#1abdde'" />
    </div>
    <section v-else class="lms-container">
      <div class="content">
        <ul class="breadcrumb">
          <li>
            <a href="#">Início</a>
          </li>
          <li>
            <a>Módulos</a>
          </li>
          <li>
            <a>Aulas</a>
          </li>
        </ul>

        <div v-if="broadcast">
          <div class="livestream-content">
            <div class="icon-content">
              <span class="icon icon-attach-86-2-2"></span>
            </div>
            <div class="text-content">
              <h5>Aula ao vivo - {{broadcast.title}}/></h5>
              <p>{{broadcast.description}}</p>
            </div>
            <div class="link-content">
              <div v-if="broadcast.type.equals('ZOOM')">
                <a href="#" class="btn" target="_blank">Ir para a aula</a>
              </div>
              <div v-else-if="broadcast.type.equals('YOUTUBE')">
                <a href="#">Ir para a aula</a>
              </div>
            </div>
          </div>
        </div>

        <div class="modules-content">
          <div class="title-section-content">
            <h3>Módulos do curso: {{course.name}}</h3>
          </div>

          <div v-if="modules == null || modules.length == 0">
            <div class="placeholder-message">
              <p>Esta turma ainda não tem módulos disponíveis.</p>
            </div>
          </div>

          <div v-for="(module,index) in modules" :key="module.id" class="module-item">
            <div class="title-content">
              <h3 class="module-title">
                {{module.name}}
                <i class="icon icon-alert-circle-i"></i>
                <div class="module-description-tooltip">{{module.description}}</div>
              </h3>
              <div class="hide-module-div"></div>
              <div class="hide-module-div"></div>

              <!-- <lms-button
                :disabled="!previousDone(index)"
                v-if="module.quizAvailable && (module.quizDone == false) && module.hasQuiz"
                @click="executeQuiz = true;selectedModuleId=module.id;"
                :loading="false"
              >Relizar teste</lms-button>
              <lms-button
                v-if="module.quizDone == true && !module.approved"
                class="btn-danger"
                :disabled="true"
                :loading="false"
              >Reprovado</lms-button>
              <lms-button
                v-if="module.quizDone == true && module.approved"
                class="btn-success"
                :disabled="true"
                :loading="false"
              >Avaliação realizada</lms-button> -->
            </div>

            <div v-if="module.lessons == undefined || module.lessons.length == 0">
              <div class="placeholder-message">
                <h5>Este módulo ainda não tem aulas disponíveis.</h5>
              </div>
            </div>
            <div v-else>
              <li class="lesson-subtitle custom-grid">
                <span class="lesson-video">Vídeos</span>
                <span class="lesson-title">Aula</span>
                <span class="lesson-description">Professor</span>
                <!-- <span class="lesson-option"></span> -->
                <span class="lesson-option"></span>
              </li>

              <ul class="lessons-list">
                <li
                  v-for="lesson in module.lessons"
                  :key="lesson.id"
                  class="lesson custom-grid"
                  style="overflow-x:auto;"
                >
                  <span
                    class="lesson-video"
                  >{{lesson.videos}} {{ lesson.videos > 1 ? 'Vídeos':'Vídeo' }}</span>
                  <span class="lesson-title">{{lesson.title}}</span>
                  <span class="lesson-description">{{lesson.teacherName}}</span>
                  <!-- <span class="lesson-option">
                    <a
                      v-show="userType==0 || userType==2"
                      v-on:click="showModal = true, selectedLesson = lesson.id"
                      href="#"
                    >Compartilhar Arquivos</a>
                  </span> -->
                  <span class="lesson-option">
                    <a v-on:click="loadLesson(lesson, module)" v-show="true" href="#">Acessar aula</a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.custom-grid {
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr !important;
  }
}
.custom-link {
  padding: 0px;
}
.custom-grid-modal {
  grid-template-columns: 1fr 1fr 0.75fr !important;
}
</style>


<script>
import axios from "axios";
axios.defaults.withCredentials = true;
import Alert from "./Alert.vue";
import router from "../../router";
import ExecuteQuiz from "./ExecuteQuiz";

export default {
  data() {
    return {
      listKey: 0,
      selectedModuleId: 0,
      executeQuiz: false,
      loading: false,
      course: this.$store.getters.course,
      isAdmin: false,
      broadcast: false,
      modules: [],
      klass: {},
      message: "",
      showMessage: false,
      userType: null,
      showModal: false,
      uploadType: 0,
      files: [],
      selectedLesson: "",
      uploadingFiles: false
    };
  },
  components: {
    ExecuteQuiz,
    alert: Alert
  },
  methods: {
    loadLesson(lesson, module) {
      this.$store.commit("change_module", module);
      this.$store.commit("change_lesson", lesson);
      this.$router.push({ name: "lesson" });
      //this.$router.push({ name: 'lesson', params: {lesson_id: lesson_id }})
    },
    addFiles() {
      this.$refs.files.click();
    },

    /*
        Submits files to the server
      */
    submitFiles() {
      this.uploadingFiles = true;

      /*
          Initialize the form data
        */
      let formData = new FormData();

      /*
          Iteate over any file sent over appending the files
          to the form data.
        */
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];

        formData.append("files[" + i + "]", file);
      }

      /*
          Make the request to the POST /select-files URL
        */

      formData.append("idLesson", this.selectedLesson);

      let endpointUpload = "";

      if (this.uploadType == 0) {
        endpointUpload = "upload-courseware";
      }
      
      if (this.uploadType == 1) {
        endpointUpload = "upload-exercise";
      } 

      const path = this.$global.endpoint + "/upload/" + endpointUpload;
      axios
        .post(path, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function() {
          console.log("SUCCESS!!");
          alert("Arquivo compartilhado com sucesso");
          this.uploadingFiles = false;
          this.files = [];
        })
        .catch(function() {
          console.log("FAILURE!!");
          this.uploadingFiles = false;
        });
    },

    /*
        Handles the uploading of files
      */
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files;

      this.files = []; //just one file

       this.uploadingFiles = false;

      /*
          Adds the uploaded file to the files array
        */
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile(key) {
      this.files.splice(key, 1);
      this.files = [];
    },
    getModules() {
      let apiCall = "/module/getall";
      const path = this.$global.endpoint + apiCall;
      axios
        .post(path, { courseId: this.course.id })
        .then(res => {
          this.modules = res.data;
          console.log(this.modules);
          this.loading = false;
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
          this.loading = false;
        });
    },
    previousDone(index) {
      if (index > 0) {
        let currentModule = this.modules[index];
        let previousModule = this.modules[index - 1];
        console.log(previousModule.approved);
        return previousModule.approved;
      } else {
        return true;
      }
    },
    modulesDrag() {
      this.listKey += 1;
    }
  },
  created() {
    this.loading = true;
    this.getModules();
    this.userType = this.$store.getters.user.type;
  }
};
</script>


